import { render, staticRenderFns } from "./PosterCreation.vue?vue&type=template&id=1a92b2bb"
import script from "./PosterCreation.vue?vue&type=script&lang=js"
export * from "./PosterCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports